(function(){
  var KEY='velox_wishlist';
  function get(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return[]}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a))}catch(e){}}
  function has(h){return get().some(function(x){return x.handle===h})}
  function esc(s){return (s||'').replace(/[<>&"]/g,function(c){return({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'})[c]});}
  function toggle(d){var a=get();var i=-1;for(var k=0;k<a.length;k++){if(a[k].handle===d.handle){i=k;break;}}if(i>=0){a.splice(i,1);}else{a.push(d);}save(a);return i<0;}
  function counts(){var c=get().length;document.querySelectorAll('[data-wishlist-count]').forEach(function(el){el.textContent=c;el.style.display=c>0?'':'none';});}
  function marks(){document.querySelectorAll('[data-wishlist-handle]').forEach(function(b){b.classList.toggle('is-active',has(b.getAttribute('data-wishlist-handle')));});}
  function card(p){
    return '<div class="pcard">'+
      '<a href="'+p.url+'" class="pcard__media">'+(p.image?'<img class="pcard__img" src="'+p.image+'" alt="">':'')+'</a>'+
      '<button class="pcard__wish is-active" aria-label="Remove from wishlist" data-wishlist-handle="'+esc(p.handle)+'" data-title="'+esc(p.title)+'" data-image="'+esc(p.image)+'" data-price="'+esc(p.price)+'" data-url="'+esc(p.url)+'">'+
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>'+
      '</button>'+
      '<div class="pcard__body">'+
        '<a href="'+p.url+'" class="pcard__title">'+esc(p.title)+'</a>'+
        '<div class="pcard__price"><span class="pcard__now">'+esc(p.price)+'</span></div>'+
        '<a href="'+p.url+'" class="pcard__add">View Product <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>'+
      '</div>'+
    '</div>';
  }
  function renderPage(){
    var wrap=document.querySelector('[data-wishlist-page]'); if(!wrap)return;
    var a=get();
    if(!a.length){wrap.innerHTML='<div class="wl-empty"><p>Your wishlist is empty.</p><a class="btn btn--dark" href="/collections/all">Browse Products</a></div>';return;}
    wrap.innerHTML='<div class="plp-grid">'+a.map(card).join('')+'</div>';
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wishlist-handle]'); if(!b)return; e.preventDefault();
    var added=toggle({handle:b.getAttribute('data-wishlist-handle'),title:b.getAttribute('data-title'),image:b.getAttribute('data-image'),price:b.getAttribute('data-price'),url:b.getAttribute('data-url')});
    b.classList.toggle('is-active',added); counts();
    if(document.querySelector('[data-wishlist-page]')) renderPage();
  });
  function init(){marks();counts();renderPage();}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();
